<template>
<div class="section-menu mt-2 ml-3">
    <!-- <div class="menu-item complete" style="height:15px;"></div> -->
    <div v-for="element in root.elements" :key="element.title">
        <div class="menu-item page hoverable clickable" 
            :class="{'active': isActive(element),'complete': element.percent > 54}" @click="nodeClicked(element, null)">
            <div style="flex-basis:40px;">
                <div class="behind-circular">
                <v-progress-circular background-color="grey lighten-2" color="blue lighten-1" :width="5" :size="35" :rotate="265" :value="element.percent" class="solid" style="border-radius:4px;margin:-1px">
                        <v-icon v-if="element.percent > 0" color="blue darken-1" class="check-icon">{{(element.percent == 100 ? 'check' : 'more_horiz')}}</v-icon>
                        <v-icon color="blue darken-1" class="arrow-icon">{{element.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}</v-icon>
                </v-progress-circular>
                </div>
            </div>
            <div style="flex-grow: 1;padding:5px;border-radius:0 18px 18px 0;">{{element.title}}</div>
            <div class="callout"></div>

        </div>
        <v-expand-transition>
        <div v-if="element.expanded" class="sections">
            <div v-for="subElement in element.elements" class="menu-item section hoverable clickable"  :key="subElement.title"
                :class="{'active': isActive(subElement), 'complete': subElement.complete}"
                @click="nodeClicked(element, subElement)">
                <div style="flex-basis:40px;">
                    <!-- The horizontal branch coming out of the root -->
                    <div class="horizontal-branch"></div>
                </div>
                <div style="padding:10px 5px;flex-grow:1">
                    {{subElement.title}}
                </div>
                <div class="callout"></div>
            </div>
        </div>
        </v-expand-transition>
    </div>
</div>
</template>

<script>
import DataHelpers from '../helpers/DataHelpers'

export default {
    data() {
        return {
        
        }
    },

    components: {
        
    },
    
    props: {
        root: Object,
        activeKey: String,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        nodeClicked(element, section) {
            if(!section)
                this.$set(element, 'expanded', !element.expanded)
            this.$emit('click', element, section)
        },

        isActive(menu) {
            return (this.activeKey && menu.key == this.activeKey)
        }
    },

    created() {

    }
}
</script>

<style scoped>

    .menu-item.active .callout {
        width: 0; 
        height: 0; 
        border-top: 15px solid transparent;
        border-bottom: 15px solid transparent; 
        
        border-right:15px solid #ddd; 
        margin-right:-1px;
        margin-top:5px;
    }

    .menu-item.active:hover {
        background-color:transparent;
    }

    .menu-item {
        /* border:solid 1px #ddd; */
        display:flex;
        border-radius:20px;
        font-size:16px;
        color:#555;
        position:relative;
    }

    .menu-item.active {
        color: #1565C0;
        /* color: #228DFF; */
        /* text-shadow: 1px 1px 10px rgba(34, 141, 255, 0.2); */
    }

    .check-icon, hover-icon {
        margin-top:3px;
    }

    .menu-item:hover .check-icon{
        display:none;
    }
    .menu-item:hover .arrow-icon{
        display:inline-block;
    }
    .arrow-icon {
        display: none;
    }

    

    .page {
        /* border-left: solid 4px #bbb; */
        /* margin-top:10px; */
        padding: 5px 0;
        
    }
    /* .sections { 
        transition: all .3s ease-in-out;
        visi
    }

    .sections.expanded {
        height:auto;
        opacity:1;
    } */
    

    .section-menu {
        position:relative;
    }

    /* .section-menu::before {
        content: '';
        position:absolute;
        top:0; left:15px; width: 5px; height:100%;
        background-color:#ddd;
        border-radius: 3px;
        z-index: -1;
    } */
    .menu-item::before {
        content: '';
        position:absolute;
        top:0; left:15px; width: 5px; height:100%;
        background-color:#ccc;
        /* border-radius: 3px; */
        z-index: -1;
    }

    .horizontal-branch {
        height:5px;border-radius:3px;background-color:#ccc;width:15px;margin-left:17px;margin-top:18px;
    }

    /* Branches that are complete */
    .menu-item.complete::before, .menu-item.complete .horizontal-branch {
        /* background-color:#1976d2; */
        /* background-color:#64B5F6; */
        background-color:#42a5f5;
    }

    .behind-circular {
        width:32px;height:32px;border-radius:16px;background-color:#eee;
    }
    .menu-item.complete .behind-circular {
        background-color: #bbdefb;
    }


   
</style>




// WEBPACK FOOTER //
// ElementMenu.vue?dfd10a84